import {
  FormValueObject,
  FormValues,
  Step,
  WizardStepChangeEventHandler,
} from 'components/types'
import { Location } from 'newTypes/location'
import { ChangeEvent, ReactElement } from 'react'
import { FieldChangeEventAnswer } from 'types/general'

import {
  EmailInput,
  NumberInput,
  DateSelect,
  LocationInput,
  MoneyInput,
  BooleanInput,
  ImageUpload,
  TextInput,
  PhoneInput,
  PasswordInput,
  MultiSelect,
  //   Textarea,
  //   Select,
  //   YearSelector,
  //   UrlInput,
} from '../common/field'
import MultiStep from './MultiStep'
import Review from './Review'

interface FieldRenderProps {
  field: Step
  formValues: FormValues
  isFirstInput?: boolean
  parentStep?: string
  updateFormValue: (value: WizardStepChangeEventHandler | ChangeEvent<HTMLInputElement> | FieldChangeEventAnswer | Location) => void
  setIsStepValid: (value: boolean) => void
}

const FieldRender = ({
  field,
  formValues,
  isFirstInput = true,
  parentStep,
  updateFormValue,
  setIsStepValid,
}: FieldRenderProps): ReactElement | null => {
  switch (field.type) {
    case 'email':
      return (
        <EmailInput
          name={field.name}
          label={field.label}
          value={(formValues[field.name] || '') as string}
          icon={field.icon}
          errorMessage={field.errorMessage}
          required={field.required}
          isFirstInput={isFirstInput}
          onChange={updateFormValue}
          setIsValid={setIsStepValid}
        />
      )
    case 'number':
      return (
        <NumberInput
          name={field.name}
          label={field.label}
          value={(formValues[field.name] || '') as string}
          icon={field.icon}
          required={field.required}
          isFirstInput={isFirstInput}
          onChange={updateFormValue}
          setIsValid={setIsStepValid}
        />
      )
    case 'date':
      return (
        <DateSelect
          name={field.name}
          label={field.label}
          value={(formValues[field.name] || '') as string}
          required={field.required}
          isFirstInput={isFirstInput}
          onChange={updateFormValue}
          setIsValid={setIsStepValid}
        />
      )
    case 'location':
      return (
        <LocationInput
          name={field.name}
          label={field.label}
          value={(formValues[field.name] || '') as string}
          icon={field.icon}
          required={field.required}
          isFirstInput={isFirstInput}
          onChange={updateFormValue}
          setIsValid={setIsStepValid}
        />
      )
    case 'money':
      return (
        <MoneyInput
          name={field.name}
          label={field.label}
          value={(formValues[field.name] || '') as string}
          required={field.required}
          isFirstInput={isFirstInput}
          onChange={updateFormValue}
          setIsValid={setIsStepValid}
        />
      )
    case 'boolean': {
      let caseValue

      if (parentStep) {
        const parentStepValue = formValues[parentStep] as FormValueObject
        caseValue = parentStepValue?.[field.name as string]?.value
      } else {
        caseValue = formValues[field.name]
      }

      return (
        <BooleanInput
          name={field.name}
          label={field.label}
          parentStep={parentStep}
          value={caseValue as string}
          onChange={updateFormValue}
          setIsValid={setIsStepValid}
        />
      )
    }
    case 'imageUpload':
      return (
        <ImageUpload
          name={field.name}
          label={field.label}
          files={formValues[field.name] as File[]}
          required={field.required}
          onChange={updateFormValue}
          setIsValid={setIsStepValid}
        />
      )
    case 'textInput':
      return (
        <TextInput
          name={field.name}
          label={field.label}
          value={(formValues[field.name] || '') as string}
          errorMessage={field.errorMessage}
          required={field.required}
          onChange={updateFormValue}
          setIsValid={setIsStepValid}
          isFirstInput={isFirstInput}
        />
      )
    case 'phone':
      return (
        <PhoneInput
          name={field.name}
          label={field.label}
          value={(formValues[field.name] || '') as string}
          errorMessage={field.errorMessage}
          required={field.required}
          onChange={updateFormValue}
          setIsValid={setIsStepValid}
          isFirstInput={isFirstInput}
        />
      )
    case 'password':
      return (
        <PasswordInput
          name={field.name}
          label={field.label}
          value={(formValues[field.name] || '') as string}
          errorMessage={field.errorMessage}
          required={field.required}
          onChange={updateFormValue}
          setIsValid={setIsStepValid}
          isFirstInput={isFirstInput}
          isValidationRequired
        />
      )
    case 'options':
      return (
        <MultiSelect
          name={field.name}
          label={field.label}
          options={field.options}
          value={(formValues[field.name] || '') as string}
          errorMessage={field.errorMessage}
          required={field.required}
          onChange={updateFormValue}
          setIsValid={setIsStepValid}
        />
      )
    // case 'inputTextarea':
    //   return (
    //     <Textarea
    //       name={field.name}
    //       label={field.label}
    //       value={(formValues[field.name] || '') as string}
    //       required={field.required}
    //       onChange={updateFormValue}
    //       setIsValid={setIsStepValid}
    //       isFirstInput={isFirstInput}
    //     />
    //   )

    // case 'select':
    //   return (
    //     <Select
    //       name={field.name}
    //       label={field.label}
    //       value={(formValues[field.name] || '') as string}
    //       required={field.required}
    //       options={field.options.map(option => option.value)}
    //       onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
    //         updateFormValue(e as unknown as React.ChangeEvent<HTMLInputElement>)
    //       }
    //       setIsValid={setIsStepValid}
    //       isFirstInput={isFirstInput}
    //     />
    //   )

    // case 'url':
    //   return <UrlInput value={url} onChange={setUrl} />

    // case 'yearField':
    //   return (
    //     <YearSelector
    //       selectedYear={selectedYear}
    //       onChange={setSelectedYear}
    //       startYear={1950}
    //       endYear={2030}
    //     />
    //   )

    case 'multiStep':
      return (
        <MultiStep
          name={field.name}
          label={field.label}
          subSteps={field?.subSteps}
          formValues={formValues}
          updateFormValue={updateFormValue}
          setIsStepValid={setIsStepValid}
        />
      )
    case 'check_info': {
      if (!field.stepsName) return null

      return (
        <Review
          stepsName={field.stepsName}
          label={field.label}
          formValues={formValues}
          onChange={updateFormValue}
          setIsValid={setIsStepValid}
        />
      )
    }

    default:
      return null
  }
}

export default FieldRender
